<template>
  <Galleria :value="value" :numVisible="5" containerStyle="max-width: 640px">
    <template #item="props">
      <img :src="props.item.file.url" style="width: 100%" />
      <Button
        icon="pi pi-times"
        class="p-button-rounded p-button-secondary"
        @click="$emit('remove', props.item.fileId || props.item.id)"
      />
    </template>
    <template #thumbnail="props">
      <img :src="props.item.file.url" style="width: 100%" />
    </template>
  </Galleria>
</template>

<script>
import Galleria from 'primevue/galleria';

export default {
  name: 'AppGaleria',
  components: {
    Galleria,
  },
  props: {
    value: Object,
  }
};
</script>

<style scoped>
.p-button {
  right: -5px;
  top: -5px;
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  height: 2rem !important;
  width: 2rem !important;
}
.p-button:hover {
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>